import { render, staticRenderFns } from "./ExamInternalFooter.vue?vue&type=template&id=93638faa&scoped=true&"
import script from "./ExamInternalFooter.vue?vue&type=script&lang=js&"
export * from "./ExamInternalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExamInternalFooter.vue?vue&type=style&index=0&id=93638faa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93638faa",
  null
  
)

export default component.exports